export const ROUTES = {
  HOME: '/',

  // ONBOARDING
  ONBOARDING_LANDING: '/onboarding_landing',
  ONBOARDING: '/onboarding',
  ONBOARDING_VIEW: '/onboarding/:onbId/view',
  GENERATE_MODELS: '/onboarding/generate-models',
  NEW_ONBOARDING: '/onboarding/new-onboarding',
  RE_ONBOARDING: '/onboarding/re-onboarding',
  NEW_EXPRESS_ONBOARDING: '/onboarding/data-enrichment-plus-modeling-tool',
  NEW_DATA_ENRICHMENT: '/onboarding/data-enrichment-tool/:enrichmentType',

  DATA_ENRICHMENT_DOWNLOAD: '/onboarding/data-enrichment-download',

  // SEGMENTS
  SEGMENTS: '/datasets',
  VIEW_SEGMENTS: '/:entity/:entityId/view',
  COMPARE_SEGMENTS: '/segments/compare',
  SEGMENTS_PRED_MODEL: '/segments/:segmentId/pred-model',
  SEGMENTS_FACETS_VIEW: '/segments/:segmentId/facets-view',
  SEGMENTS_OCEAN_VIEW: '/segments/:segmentId/ocean-view',

  // CLUSTERS
  CLUSTERS: '/segments/:segmentId/clusters',

  // MODELS
  MODELS: '/models', // List page
  MODEL_LIFT_CHARTS: '/models/:modelClass/:modelId/lift-charts',
  MODEL_INPUT_DISTRIBUTIONS: '/models/:modelClass/:modelId/input-distributions',
  MODEL_VALIDATION_ANALYTICS: '/models/:modelClass/:modelId/validation-analytics',
  MODEL_ROI_CALCULATOR: '/models/:modelClass/:modelId/roi-calculator',
  MODELS_COMPARE: '/models/:modelClass/compare',

  // REAL TIME API
  REAL_TIME_API: '/rt',
  REAL_TIME_API_DEMO: '/rt/:configId',
  REAL_TIME_API_DOCUMENTATION: '/rt/documentation',
  REAL_TIME_API_DOCUMENTATION_CONFIG: '/rt/documentation/:configId',
  REAL_TIME_API_USAGE: '/rt/usage',
  REAL_TIME_API_USAGE_CONFIG: '/rt/usage/:configId',

  // COPY PERSONALIZTION
  COPY_PX: '/copypx',

  // STORY MODE
  COMPOSER: '/composer/:datasetId',
  STORY: '/story/:datasetId',

  // USERS
  USERS: '/users',
  USERS_ADD: '/users/add',
  USERS_VIEW: '/users/:userId',

  // CLIENTS
  CLIENTS: '/clients',
  CLIENTS_ADD: '/clients/add',
  CLIENTS_EDIT: '/clients/:clientId',
  CLIENTS_EDIT_SUBS: '/clients/:clientId/subscribers',

  // AUTH
  TOKEN: '/token',
  LOGIN: '/login',
  PASSWORD_CHALLENGE: '/password-challenge',
  FORGOT_PASSWORD: '/forgot-password',
  CHANGE_PASSWORD: '/change-password',
};
